import { MetricsWrapper } from './wrapper';
import { MetricsKnobs } from './knobs';
import { PropertyType as SrsPropertyType, PropertyFlag as SrsPropertyFlag } from 'srs-middleware';
import { facets } from 'widgets/endpoints';

export const config = {
	key: 'METRICS',
	label: 'Metrics',
	icon: 'th',
	wrapper: MetricsWrapper,
	endpoint: facets,
	Knobs: MetricsKnobs,
	flags: [SrsPropertyFlag.Categorical],
	types: [SrsPropertyType.String],
	createDefaultOptions: (filteredProperties) => {
		return {
			options: {
				propertyList: [filteredProperties[0].name],
				parameters: {
					maxValues: 1000000,
					descending: false,
				},
			},
		};
	},
	createDefaultConfiguration: () => {
		return {
			showFull: true,
		};
	},
	isValid: (filteredProperties) => {
		return filteredProperties?.length > 0;
	},
};
